export default {
  state: {
    eqpTreeObj: {},
    eqpTreeLevel: null,
    eqpTreeType: null
  },
  getters: {
    'searchCondition:eqpTreeObj': state => state.eqpTreeObj,
    'searchCondition:eqpTreeLevel': state => state.eqpTreeLevel,
    'searchCondition:eqpTreeType': state => state.eqpTreeType
  },
  actions: {
    eqpTreeSelected ({ commit }, eqpTreeObj) {
      commit('setEqpTreeObj', eqpTreeObj)
    },
    eqpTreeLevel ({ commit }, eqpTreeLevel) {
      commit('setEqpTreeLevel', eqpTreeLevel)
    },
    eqpTreeType ({ commit }, eqpTreeType) {
      commit('setEqpTreeType', eqpTreeType)
    }
  },
  mutations: {
    setEqpTreeObj (state, payload) {
      state.eqpTreeObj = payload
    },
    setEqpTreeLevel (state, payload) {
      state.eqpTreeLevel = payload
    },
    setEqpTreeType (state, payload) {
      state.eqpTreeType = payload
    }
  }
}
